var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthPageEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 387,
    height: 387,
    viewBox: "0 0 387 387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    fill: "none",
    stroke: "#068ecf",
    strokeWidth: 47,
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 193.5,
    cy: 193.5,
    r: 193.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.5,
    cy: 193.5,
    r: 170,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthPageEllipse);
export default __webpack_public_path__ + "static/media/AuthPageEllipse.e263202da5c71064efed1e78f620fe20.svg";
export { ForwardRef as ReactComponent };